module.exports = __webpack_public_path__ + "img/2.0457a996.png";